import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/dataStudio/importer/dataStudioImporterActions';

export default importerReducers(actions);
